/**
 * Animation d'apparition discrète au défilement, via IntersectionObserver.
 * Respecte prefers-reduced-motion : si l'utilisateur préfère moins de
 * mouvement, les éléments sont affichés immédiatement sans transition.
 */

document.documentElement.classList.add('js');

export function initReveal(): void {
  const elements = document.querySelectorAll<HTMLElement>('.reveal');
  if (elements.length === 0) {
    return;
  }

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    elements.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
  );

  elements.forEach((el) => observer.observe(el));
}
